export const handleCountryOptions = (
  form: any,
  country: string,
  nationality_field: string,
) => {
  form.setFieldsValue({
    [nationality_field]: country,
  });
};
